module.exports = __webpack_public_path__ + "img/logo.fc80e959.svg";